import React from 'react';

import { Link } from '@dbt-labs/sourdough';

interface ResourceOwnerProps {
  owner: string | null;
  href: string;
  ctaHref: string | null;
}

const ResourceOwner: React.FC<ResourceOwnerProps> = ({ owner, href, ctaHref }) => {
  return (
    <div>
      {owner ? (
        <Link isInternal shouldOpenNewTab to={href}>
          {owner}
        </Link>
      ) : (
        <span>
          No owner.
          {ctaHref && (
            <>
              {' '}
              <Link isInternal={false} shouldOpenNewTab to={ctaHref}>
                Learn how to define.
              </Link>
            </>
          )}
        </span>
      )}
    </div>
  );
};

export default ResourceOwner;
